// extracted by mini-css-extract-plugin
module.exports = {"icon":"Link__icon___1Hxf-"};